import richText from "utilities/richText"

export default function BasicContent({ blok }) {
  return (
    <section className="max-w-screen-md mx-auto px-8 py-12 prose-h2:text-m3 lg:prose-h2:text-l1 prose-h2:text-green-pine prose-h2:leading-7 lg:prose-h2:leading-9 prose-h2:pb-1 prose-h3:text-m1 prose-h3:pb-1 prose-ol:list-decimal prose-ol:pl-4 prose-ol:pb-4 prose-ul:pb-4 prose-p:pb-4 last:prose-p:pb-0 content">
      {richText(blok.content)}
    </section>
  )
}
